import { createSlice } from '@reduxjs/toolkit';

interface BrowserState {
  loading: boolean;
  currentRequestId: undefined | string;
  error: any;
  browserConfig: any;
}

const initialState = {
  loading: false,
  currentRequestId: undefined,
  error: null,
  browserConfig: {
    deviceType: "desktop"
  }
} as BrowserState;

export const browserSlice = createSlice({
  name: 'browser',
  initialState,
  reducers: {
    resetBrowser: () => initialState,
    setBrowserDeviceType: (state, action) => {
      console.log("Inside Browser Device Type: ", action)
        state.browserConfig.deviceType = action.payload;
    },
  }
});

export const { resetBrowser, setBrowserDeviceType } = browserSlice.actions;

export default browserSlice.reducer;
